// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1Eyek","savePackageButton":"ClientWallet_savePackageButton__1NfbR"};